type TProps = {
  mainPrice: number;
  numberOfItemsInStringFormat: string;
  additionalAsMain?: boolean;
  additionalPrice: number | null;
};

export const getPrice = ({
  mainPrice,
  numberOfItemsInStringFormat,
  additionalAsMain,
  additionalPrice,
}: TProps) => {
  const numberOfItems = Number(numberOfItemsInStringFormat);

  if (additionalAsMain && additionalPrice) {
    return additionalPrice * numberOfItems;
  }

  return mainPrice * numberOfItems;
};
